// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Vy5et","left":"InfoRow_left__2SSw4"};